

























































































































import * as _ from "lodash"
import {Vue, Component, Lifecycle, Prop, Mixin, p} from 'av-ts'

import {Card} from '../deckard/models/Card'
import {Deck} from '../deckard/models/Deck'

import {CardDatabase} from '../deckard/storage/CardDatabase'
import CardGrid from './CardGrid.vue'

@Component({
    components: {'CardGrid' : CardGrid, 'contextMenu': require('vue-context-menu')}
})
export default class DeckEditor extends Vue
{
    showImportModal: boolean = false;
    textImport: string = "";

    showNewModal: boolean = false;
    newDeckName: string = "";

    get selectedDeck() : Deck
    {
        return this.$store.state.deck.currentDeck;
    }

    set selectedDeck(deck: Deck)
    {
        this.$store.commit('deck/setCurrentDeck', deck);
    }

    get currentCards()
    {
        return (this.selectedDeck != undefined ? this.selectedDeck.cards : []);
    }

    deleteDeck()
    {
        this.$store.commit('deck/deleteCurrentDeck');
        this.$store.commit('deck/setCurrentDeck', this.$store.state.allDecks[0]);
    }

    onCtxOpen(vars)
    {
        
    }

    //Do some fun form POSTing to TCGPlayer
    buyDeck()
    {
        let baseUrl = "http://store.tcgplayer.com/massentry/";
        let cardList = this.getDeckAsString("||");

        //Create a form
        let form = document.createElement("form");
        form.target = "_blank";
        form.method = "POST";
        form.action = baseUrl;
        form.style.display = "none";

        //Create the input for the form, and pass our
        //list of cards
        let input = document.createElement("input");
        input.type = "hidden";
        input.name = "c";
        input.value = cardList;
        form.appendChild(input);

        //Submit the form and delete it
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    exportDeck()
    {
        let baseUrl = "data:text/plain,";
        baseUrl = baseUrl + this.getDeckAsString("\r\n");

        let downloadLink = document.createElement("a");
        downloadLink.href = encodeURI(baseUrl);
        downloadLink.download = "myDeck.txt";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    getDeckAsString(separator: string): string
    {
        let ret: string = "";
        let cards: any = _.groupBy(this.selectedDeck.cards, function(card: Card) { return card.name });

        for (let cardGrp in cards)
        {
            ret += cards[cardGrp].length + " " + cardGrp + separator;
        }

        return ret;
    }

    importDeck()
    {
        let thisVue:DeckEditor = this;

        CardDatabase.instance.importCards(this.textImport.split('\n'))
            .then(function(cards)
            {
                let newDeck: Deck = new Deck();
                newDeck.name = thisVue.newDeckName;
                newDeck.cards = cards;

                thisVue.$store.commit('deck/loadDeck', newDeck);
                thisVue.newDeckName = "New Deck";
                thisVue.showImportModal = false;
            });
    }

    createDeck()
    {
        let newDeck: Deck = new Deck();
        newDeck.name = this.newDeckName;
        newDeck.cards = [];

        this.$store.commit('deck/loadDeck', newDeck);

        this.showNewModal = false;
        this.newDeckName = "New Deck";
    }

    removeFromDeck(card)
    {
        this.$store.commit('deck/removeFromDeck', card);
    }

    addToDeck(card)
    {
        this.$store.commit('deck/addToDeck', card);
    }

    // lifecycle hook
    @Lifecycle mounted()
    {
        
    }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/DeckEditor.vue